import { ModuleType } from "../constants/ModuleType";
import { SCORM_API_URL, LW_COURSE_API_URL } from "../constants/api.constants";

export function getWinOptions() {
  var winOptions = "toolbar=no,status=no,location=no,menubar=no,scrollbars=yes";
  winOptions = winOptions + ",width=" + window.screen.availWidth.toString();
  winOptions = winOptions + ",height=" + window.screen.availHeight.toString();
  return winOptions;
}

export function isGy25TestModule(module) {
  return module.isGy25 && !module.isFactModule && !module.isFinalExam;
}

// Scores are stored with up to 4 decimals. Round to 2 decimals so that every
// result view displays the same value for the same student and module.
export function roundScore(score) {
  return Math.round(score * 100) / 100;
}

export function composeUrl(
  userId,
  courseId,
  moduleId,
  moduleType,
  studentResultId,
  moduleUrl,
  studentName,
  numberOfRuns,
  isGy25FinalExam,
) {
  var url;
  var email = localStorage.getItem("email");
  var numOfRunsIncramented = (numberOfRuns += 1);
  if (moduleType === ModuleType.LEARNWARE || moduleType === "LearnWare") {
    url =
      `${LW_COURSE_API_URL}/Home/StartLwCourse?` +
      "email=" +
      encodeURIComponent(email) +
      "&userId=" +
      userId +
      "&courseId=" +
      courseId +
      "&moduleId=" +
      moduleId;
  } else {
    url =
      `${SCORM_API_URL}/BootstrapDialog?` +
      "userId=" +
      userId +
      "&studentResultId=" +
      studentResultId +
      "&courseId=" +
      courseId +
      "&moduleId=" +
      moduleId +
      "&url=" +
      moduleUrl +
      "&name=" +
      studentName +
      "&isGy25FinalExam=" +
      isGy25FinalExam +
      "&run=" +
      numOfRunsIncramented;
  }
  return `${url}&tick=${Date.now()}`;
}
